import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import OverflowTooltip from '../overflow_tooltip'

const SimCell = ({ children, ...props }) => {
  const divProps = _.omit(props, 'title')
  return (
    <OverflowTooltip divProps={ divProps }>
      { children }
    </OverflowTooltip>
  )
}

SimCell.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SimCell